// src/components/CategoryFilter.jsx  —  ohapotato v2026.10.36
import React from 'react';
import { CATEGORIES } from '../data/ingredients';

export default function CategoryFilter({ active, onChange }) {
  return (
    <div className="category-filter">
      {CATEGORIES.map(cat => (
        <button
          key={cat.id}
          style={{
            ...styles.btn,
            ...(active === cat.id ? styles.active : {}),
          }}
          onClick={() => onChange(cat.id)}
          onMouseDown={e => e.preventDefault()}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
}

const styles = {
  btn: {
    fontSize: '12px',
    fontWeight: '500',
    padding: '5px 12px',
    borderRadius: 'var(--radius-pill)',
    border: '1px solid var(--border-base)',
    borderColor: 'var(--border-base)',
    background: 'transparent',
    color: 'var(--text-muted)',
    cursor: 'pointer',
    fontFamily: 'var(--font-body)',
    transition: 'all 0.12s ease',
    whiteSpace: 'nowrap',
    minHeight: '30px',
    outline: 'none',
  },
  active: {
    background: 'var(--accent-orange)',
    borderColor: 'var(--accent-orange)',
    color: '#fff',
    fontWeight: '600',
  },
};
